/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_ProviderInputs */

const en_logistics_provider = /** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics Provider`)
};

const es_logistics_provider = /** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor Logístico`)
};

const fr_logistics_provider = /** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur logistique`)
};

const de_logistics_provider = /** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistikanbieter`)
};

const id_logistics_provider = /** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyedia Logistik`)
};

/** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */
const ja_logistics_provider = en_logistics_provider;

/** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */
const zh_logistics_provider = en_logistics_provider;

/** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */
const ar_logistics_provider = en_logistics_provider;

/** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */
const it_logistics_provider = en_logistics_provider;

/** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */
const ru_logistics_provider = en_logistics_provider;

/** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */
const pt_logistics_provider = en_logistics_provider;

/** @type {(inputs: Logistics_ProviderInputs) => LocalizedString} */
const ko_logistics_provider = en_logistics_provider;

/**
* | output |
* | --- |
* | "Logistics Provider" |
*
* @param {Logistics_ProviderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const logistics_provider = /** @type {((inputs?: Logistics_ProviderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_ProviderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_provider(inputs)
	if (locale === "es") return es_logistics_provider(inputs)
	if (locale === "fr") return fr_logistics_provider(inputs)
	if (locale === "de") return de_logistics_provider(inputs)
	if (locale === "ja") return ja_logistics_provider(inputs)
	if (locale === "zh") return zh_logistics_provider(inputs)
	if (locale === "ar") return ar_logistics_provider(inputs)
	if (locale === "id") return id_logistics_provider(inputs)
	if (locale === "it") return it_logistics_provider(inputs)
	if (locale === "ru") return ru_logistics_provider(inputs)
	if (locale === "pt") return pt_logistics_provider(inputs)
	return ko_logistics_provider(inputs)
});